import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeadersForOrganisation } from "./apiHelpers";

const endpoint = spellbook("/v1/feedback/{feedbackId}").PUT();

export type PutFeedbackPathParams = typeof endpoint.types.P;
export type PutFeedbackReq = typeof endpoint.types.Req;
export type PutFeedbackResponse = typeof endpoint.types.Res;

type PutFeedbackInput = {
    feedbackId: string;
    data: {
        siderId: string;
        taskId: string;
        typeId?: string;
        organisationId: string;
        managerId: string;
        pro: number;
        perf: number;
        comment: string;
    };
};

function buildPutFeedbackReq(feedbackId: string, data: PutFeedbackInput[`data`]): PutFeedbackReq {
    const base = {
        _id: feedbackId,
        taskId: data.taskId,
        organisationId: data.organisationId,
        managerId: data.managerId,
        siderId: data.siderId,
        comment: data.comment ?? ``,
        pro: data.pro,
        perf: data.perf,
    };
    if (data.typeId) {
        return { ...base, typeId: data.typeId };
    }
    return base;
}

export async function putFeedback(params: PutFeedbackInput): Promise<PutFeedbackResponse> {
    const call = createCall(endpoint, (r) =>
        fetch(withAccountOrNetworkAuthHeadersForOrganisation(r, params.data.organisationId)),
    );
    const req = buildPutFeedbackReq(params.feedbackId, params.data);
    return await call({
        params: { feedbackId: params.feedbackId },
        req,
    });
}
